export default __webpack_public_path__ + "static/media/flux.f78b3bb3.svg";